import { handleImageError } from '../../utils/imageUtils';
import { coverGradientFor } from '../../utils/coverGradient';
import { getStatusLabel } from '../../constants/forms';

const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '—';
  return `${Number(amount || 0).toLocaleString()} Ar`;
};

const exportCSV = (rows) => {
  const header = ['Titre', 'Statut', 'Streams', 'Ventes', 'Revenus (Ar)'];
  const lines = rows.map((a) => [
    `"${String(a.title || '').replace(/"/g, '""')}"`,
    getStatusLabel(a.status),
    a.streams ?? 0,
    a.sales ?? 0,
    a.revenue ?? 0,
  ].join(';'));
  const csv = '﻿' + [header.join(';'), ...lines].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'performance-sorties.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const AlbumsPerformance = ({ data, loading }) => {
  if (loading) {
    return (
      <>
        <div className="section-title-row">
          <div><span className="content-kicker">Catalogue</span><h2>Performance par sortie</h2></div>
        </div>
        <div className="dna-canvas is-empty"><span>Chargement des performances…</span></div>
      </>
    );
  }

  if (!data || data.length === 0) {
    return (
      <>
        <div className="section-title-row">
          <div><span className="content-kicker">Catalogue</span><h2>Performance par sortie</h2></div>
        </div>
        <div className="community-placeholder">
          <span className="content-kicker">Aucune donnée</span>
          <h2>Pas encore de statistiques.</h2>
          <p>Crée ta première sortie pour voir ses performances ici.</p>
        </div>
      </>
    );
  }

  const maxStreams = Math.max(1, ...data.map((a) => Number(a.streams) || 0));

  return (
    <>
      <div className="section-title-row">
        <div><span className="content-kicker">Catalogue</span><h2>Performance par sortie</h2></div>
        <button type="button" className="view-all" onClick={() => exportCSV(data)}>
          Exporter CSV <i className="fa-solid fa-arrow-right" style={{ fontSize: '.7rem' }} />
        </button>
      </div>
      {data.map((album) => {
        const streams = Number(album.streams) || 0;
        const pct = Math.min(100, Math.round((streams / maxStreams) * 100));
        return (
          <div className="performance-row" key={album.id}>
            <span className="performance-cover" style={album.cover_url ? undefined : { background: coverGradientFor(album.id) }}>
              {album.cover_url ? (
                <img src={album.cover_url} alt={album.title} onError={handleImageError} />
              ) : (
                <span aria-hidden="true">{(album.title || 'P')[0].toUpperCase()}</span>
              )}
            </span>
            <div className="performance-name">
              <b>{album.title}</b>
              <small>{getStatusLabel(album.status)}</small>
            </div>
            <span>{streams.toLocaleString()} écoutes</span>
            <div className="performance-bar"><i style={{ width: `${pct}%` }} /></div>
            <b>{formatCurrency(album.revenue)}</b>
          </div>
        );
      })}
    </>
  );
};

export default AlbumsPerformance;
